import { EventEmitter, Injectable, OnInit, Output } from "@angular/core";
import { BehaviorSubject, ReplaySubject } from "rxjs";
import { CHECKOUT_ROUTE, USER_ROUTES } from "../../constants/constants";
import { MERCHANT_ROUTES } from "../../global/constants";
import { HttpRequestsService } from "../http-requests.service";
import { ApiService } from "../api.service";

@Injectable({
  providedIn: "root",
})
export class MerchantService implements OnInit {
  private historyData = new ReplaySubject<any>(1);
  @Output() aClickedEvent = new EventEmitter<any>();
  private loading$ = new BehaviorSubject<boolean>(false);
  public checkouts = new BehaviorSubject<any[]>([]);
  public isLoadingCheckout = new BehaviorSubject<boolean>(false);
  public isGetCheckouts = false;
  public profile: any;
  constructor(
    private http: HttpRequestsService,
    private readonly apiService: ApiService,
  ) {}

  ngOnInit(): void {
    if (this.apiService.token) {
      this.getCheckouts();
    }
  }

  async merchantBalanceData() {
    return await this.http.get(USER_ROUTES.BALANCE_DATA, false);
  }

  async getMerchantTransactions(data) {
    return await this.http.post(USER_ROUTES.ANALYTICS_DATA, data, false);
  }

  // TODO: model definition for merchant profile
  async getProfile(): Promise<any> {
    if (!this.profile) {
      const res: any = await this.http.get(MERCHANT_ROUTES.PROFILE, false);
      this.profile = res.data;
    }
    return this.profile;
  }

  async setProfile() {
    const res: any = await this.http.get(MERCHANT_ROUTES.PROFILE, false);
    this.profile = res.data;
  }

  async merchantThingsToDo() {
    return await this.http.get(USER_ROUTES.MERCHANT_THINGS_TO_DO, false);
  }

  postClick = async (id) => {
    return await this.http.post(`${USER_ROUTES.POST_CLICK}/${id}`, false);
  };
  postBannerClose = async (id, merchantId) => {
    return await this.http.post(
      `${USER_ROUTES.POST_BANNER_CLOSE}/${id}/${merchantId}`,
      null,
      true,
    );
  };
  setHistoryData(data: any) {
    this.historyData.next(data);
  }

  getHistoryData() {
    return this.historyData.asObservable();
  }

  async getSettlementList(limit: number = 10, page: number = 1) {
    return await this.http.get(
      `${CHECKOUT_ROUTE.MERCHANT_SETTLEMENT_LIST}?page=${page}&limit=${limit}`,
    );
  }

  async getDashboardGraphData() {
    return await this.http.get(`${USER_ROUTES.DASHBOARD_GRAPH_DATA}`, false);
  }
  async postTransactionDownload(data) {
    return await this.http.post(
      `${USER_ROUTES.TRANSACTION_STATEMENT}`,
      data,
      false,
    );
  }
  async UrlToBase64(data) {
    return await this.http.post(`${USER_ROUTES.URL_TO_BASE64}`, data, false);
  }

  async getCheckouts() {
    if (!this.isGetCheckouts) {
      this.isLoadingCheckout.next(true);
      const checkouts: any = await this.http.get(
        `${MERCHANT_ROUTES.CHECKOUTS}`,
        false,
      );
      this.checkouts.next(checkouts.data as any[]);
      this.isLoadingCheckout.next(false);
    }
    return this.checkouts.getValue();
  }

  setLoading(value: boolean) {
    this.loading$.next(value);
  }

  getLoading() {
    return this.loading$.asObservable();
  }

  sendBusinessDocumentsEmail() {
    return this.http.get(MERCHANT_ROUTES.SEND_DOCUMENT_REQUEST_EMAIL, false);
  }
}
